/* eslint no-console:0 */

import '@phosphor-icons/web/light';
import '@phosphor-icons/web/regular';
import '@phosphor-icons/web/fill';

import '../styles/storefront/redesign.css';

const PRODUCT_SIZE_CHART_SELECTOR = '#size-chart';

const renderProductGallery = (root) => {
  if (!root) return;

  const track = root.querySelector('[data-product-gallery-track]');
  const slides = Array.from(root.querySelectorAll('[data-product-gallery-slide]'));
  const thumbs = Array.from(root.querySelectorAll('[data-product-gallery-thumb]'));
  const prevButton = root.querySelector('[data-product-gallery-prev]');
  const nextButton = root.querySelector('[data-product-gallery-next]');

  if (!track || slides.length <= 1) {
    return;
  }

  const maxIndex = slides.length - 1;
  const activeIndex = Math.min(Math.max(Number(root.dataset.activeIndex || 0), 0), maxIndex);

  root.dataset.activeIndex = String(activeIndex);
  track.style.transform = `translateX(-${activeIndex * 100}%)`;

  slides.forEach((slide, index) => {
    slide.classList.toggle('is-active', index === activeIndex);
  });

  thumbs.forEach((thumb, index) => {
    thumb.classList.toggle('is-active', index === activeIndex);
  });

  if (prevButton) prevButton.disabled = activeIndex === 0;
  if (nextButton) nextButton.disabled = activeIndex === maxIndex;
};

const bootProductGalleries = () => {
  document.querySelectorAll('[data-product-gallery]').forEach(renderProductGallery);
};

const stepProductGallery = (root, nextIndex) => {
  if (!root) return;

  root.dataset.activeIndex = String(nextIndex);
  renderProductGallery(root);
};

const initProductGalleryEvents = () => {
  if (document.body.dataset.productGalleryEventsReady === 'true') return;

  document.addEventListener('click', (event) => {
    const galleryAction = event.target.closest('[data-product-gallery-prev], [data-product-gallery-next], [data-product-gallery-thumb]');

    if (!galleryAction) return;

    const root = galleryAction.closest('[data-product-gallery]');
    const slides = root ? Array.from(root.querySelectorAll('[data-product-gallery-slide]')) : [];

    if (!root || slides.length <= 1) return;

    const currentIndex = Number(root.dataset.activeIndex || 0);
    const maxIndex = slides.length - 1;

    if (galleryAction.hasAttribute('data-product-gallery-prev')) {
      event.preventDefault();
      stepProductGallery(root, Math.max(currentIndex - 1, 0));
      return;
    }

    if (galleryAction.hasAttribute('data-product-gallery-next')) {
      event.preventDefault();
      stepProductGallery(root, Math.min(currentIndex + 1, maxIndex));
      return;
    }

    event.preventDefault();
    stepProductGallery(root, Number(galleryAction.dataset.index || 0));
  });

  document.body.dataset.productGalleryEventsReady = 'true';
};

const ensureSizeChartModalInBody = (modal) => {
  if (!modal || modal.parentElement === document.body) return modal;

  document.body.appendChild(modal);
  return modal;
};

const getOrCreateModalBackdrop = () => {
  let backdrop = document.querySelector('.modal-backdrop[data-generated-by="storefront"]');

  if (backdrop) return backdrop;

  backdrop = document.createElement('div');
  backdrop.className = 'modal-backdrop fade';
  backdrop.dataset.generatedBy = 'storefront';
  document.body.appendChild(backdrop);

  return backdrop;
};

const closeSizeChartModal = () => {
  const modal = document.querySelector(PRODUCT_SIZE_CHART_SELECTOR);
  const backdrop = document.querySelector('.modal-backdrop[data-generated-by="storefront"]');

  if (!modal) return;

  modal.classList.remove('show');
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('modal-open');

  if (backdrop) {
    backdrop.classList.remove('show');
    backdrop.remove();
  }
};

const openSizeChartModal = (modal) => {
  if (!modal) return;

  ensureSizeChartModalInBody(modal);
  const backdrop = getOrCreateModalBackdrop();

  backdrop.classList.add('show');
  modal.classList.add('show');
  modal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('modal-open');
};

const initSizeChartModal = () => {
  if (document.body.dataset.sizeChartModalReady === 'true') return;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(`[data-bs-toggle="modal"][data-bs-target="${PRODUCT_SIZE_CHART_SELECTOR}"]`);
    const closeButton = event.target.closest(`${PRODUCT_SIZE_CHART_SELECTOR} [data-bs-dismiss="modal"]`);
    const modal = document.querySelector(PRODUCT_SIZE_CHART_SELECTOR);

    if (trigger) {
      event.preventDefault();
      openSizeChartModal(modal);
      return;
    }

    if (closeButton) {
      event.preventDefault();
      closeSizeChartModal();
      return;
    }

    if (modal && event.target === modal) {
      closeSizeChartModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSizeChartModal();
    }
  });

  document.body.dataset.sizeChartModalReady = 'true';
};

const initStorefrontInteractions = () => {
  initProductGalleryEvents();
  bootProductGalleries();
  initSizeChartModal();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStorefrontInteractions, { once: true });
} else {
  initStorefrontInteractions();
}

window.addEventListener('load', bootProductGalleries, { once: true });
document.addEventListener('shopAppMounted', bootProductGalleries);

const storefrontObserver = new MutationObserver(() => {
  bootProductGalleries();
});

if (document.body) {
  storefrontObserver.observe(document.body, { childList: true, subtree: true });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    storefrontObserver.observe(document.body, { childList: true, subtree: true });
  }, { once: true });
}
